import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'
import BlockCardV3 from './Cards/BlockCardV3'

function Pagination({ data }) {
  const { itemsPerPage, items, grid } = data
  const [currentItems, setCurrentItems] = useState(null)
  const [pageCount, setPageCount] = useState(0)
  const [itemOffset, setItemOffset] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage
    setCurrentItems(items.slice(itemOffset, endOffset))
    setPageCount(Math.ceil(items.length / itemsPerPage))
  }, [itemOffset, itemsPerPage])

  const handlePageClick = event => {
    const newOffset = (event.selected * itemsPerPage) % items.length
    setItemOffset(newOffset)
    setCurrentPage(event.selected + 1)
  }

  const gridClass = columns => {
    if (columns === 'multiples of 3') {
      return 'grid-three-columns'
    }

    if (columns === 'multiples of 2') {
      return 'grid-two-columns'
    }

    if (columns === 'multiples of 2 (left is wider)') {
      return 'grid-two-columns-left-wider'
    }
    return 'grid-default'
  }

  const cards =
    currentItems &&
    currentItems.map((card, index) => {
      return (
        <BlockCardV3
          data={card}
          key={card.slug}
          grid
          columns={gridClass(grid)}
          blog
          theme="White"
          cardNumber={index}
        />
      )
    })

  return (
    <div className="bg-white">
      <div className={`${gridClass(grid)}`}>{cards}</div>
      <ReactPaginate
        previousLabel={currentPage > 1 ? '<' : ''}
        nextLabel={currentPage < pageCount ? '>' : ''}
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-item"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName="pagination"
        activeClassName="active"
      />
    </div>
  )
}

Pagination.propTypes = {
  data: PropTypes.object.isRequired
}

export default Pagination
